import { render } from "./v-cart-item.vue?vue&type=template&id=a990b0b2&scoped=true"
import script from "./v-cart-item.vue?vue&type=script&lang=js"
export * from "./v-cart-item.vue?vue&type=script&lang=js"

import "./v-cart-item.vue?vue&type=style&index=0&id=a990b0b2&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a990b0b2"]])

export default __exports__